import MenuIcon from '@mui/icons-material/Menu';
import {Box, Slide, Zoom} from '@mui/material';
import Card from '@mui/material/Card';
import Hidden from '@mui/material/Hidden';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';

import {useLayoutContext} from 'main/utility/AppContextProvider/LayoutContextProvider';
import {onToggleAppDrawer} from 'redux/actions';
import {Fonts} from 'shared/constants/AppEnums';
import AppContainerWrapper from './AppContainerWrapper';
import AppSidebar from './AppSidebar';

const appsContainerDefault = {
  title: '',
};

const AppsContainer = (props = {appsContainerDefault}) => {
  const dispatch = useDispatch();
  const isAppDrawerOpen = useSelector(
    ({commonReducer}) => commonReducer.isAppDrawerOpen,
  );
  const {footer} = useLayoutContext();
  const {navStyle} = useLayoutContext();
  const {title, sidebarContent, fullView, children, isSingleWidget} = props;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        margin: -4,
        padding: 4,
        ...props.sxStyle,
      }}
    >
      {fullView && title?.length > 0 && (
        <Box
          sx={{
            marginTop: fullView ? 0 : -4,
            display: 'flex',
            alignItems: 'center',
            mb: {
              xs: fullView ? 4 : 2,
              lg: 4,
            },
            mt: {
              xs: fullView ? 0 : -4,
              lg: 0,
            },
          }}
        >
          {fullView ? null : (
            <Hidden lgUp>
              <IconButton
                edge='start'
                sx={{
                  marginRight: (theme) => theme.spacing(2),
                }}
                color='inherit'
                aria-label='open drawer'
                onClick={() => dispatch(onToggleAppDrawer())}
                size='large'
              >
                <MenuIcon
                  sx={{
                    width: 35,
                    height: 35,
                  }}
                />
              </IconButton>
            </Hidden>
          )}
          <Zoom in style={{transitionDelay: '300ms'}}>
            <Box
              component='h2'
              variant='h2'
              sx={{
                fontSize: 16,
                color: 'text.primary',
                fontWeight: Fonts.SEMI_BOLD,
              }}
            >
              {title}
            </Box>
          </Zoom>
        </Box>
      )}

      <AppContainerWrapper
        navStyle={navStyle}
        footer={footer}
        isSingleWidget={isSingleWidget}
      >
        {sidebarContent ? (
          <AppSidebar
            isAppDrawerOpen={isAppDrawerOpen}
            footer={footer}
            fullView={fullView}
            navStyle={navStyle}
            sidebarContent={sidebarContent}
          />
        ) : null}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: {
              xs: '100%',
              lg: `calc(100% - ${fullView ? 0 : 280}px)`,
            },
            pl: {
              lg: props.fullView ? 0 : 8,
            },
          }}
        >
          <Slide direction='left' in mountOnEnter unmountOnExit>
            <Card
              style={{
                height: isSingleWidget ? '100%' : 'auto',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                ...props.cardStyle,
              }}
            >
              {children}
            </Card>
          </Slide>
        </Box>
      </AppContainerWrapper>
    </Box>
  );
};

export default AppsContainer;

AppsContainer.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sidebarContent: PropTypes.node,
  fullView: PropTypes.bool,
  children: PropTypes.node,
  sxStyle: PropTypes.object,
  cardStyle: PropTypes.object,
  isSingleWidget: PropTypes.bool,
};
